import React from "react";
import ReactDOM from "react-dom/client";
import NavigationRouter from "./interface/navigation/index";
// REDUX
import { Provider } from "react-redux";
import { axiosConfig } from "./common/ulti/axiosConfig";
import store from "controller/redux/store";
// common
import "common/assets/scss/index.scss";
import "common/assets/js/index";
import { ConfigProvider } from "antd";
import { ThemeProvider } from "styled-components";
import { customTheme, GlobalStyle } from "common/assets/js/global";

import { HelmetProvider } from "react-helmet-async";

axiosConfig(store);

function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <ConfigProvider theme={customTheme}>
          <ThemeProvider theme={{}}>
            <GlobalStyle />
            <NavigationRouter />
          </ThemeProvider>
        </ConfigProvider>
      </Provider>
    </HelmetProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
